module.exports = __webpack_public_path__ + "fonts/sole.6ef3759.woff";